import React from "react";
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import MainCard from "components/MainCard";
import ServiceCard from "./ServiceCard";

import Divider from "@mui/material/Divider";
import EnvironmentOutlined from "@ant-design/icons/EnvironmentOutlined";

const SiteBasedBlock = ({
  sites,
  deviceCounts = {},
  siteLevelServices,
  siteSubscriptions,
  onAction,
}) => {
  const theme = useTheme();

  return (
    <Box>
      <Stack spacing={2}>
        <Typography
          sx={{
            color: "#172664",
            fontSize: "15px",
            fontWeight: "bold",
          }}
        >
          Site-based Services
        </Typography>
        <Divider sx={{ borderColor: "rgba(0,0,0,0.08)" }} />
        <Typography variant='body2' color='textSecondary' sx={{ mb: 1 }}>
          Activate or deactivate services per site. Credits are deducted based
          on active devices.
        </Typography>

        <Grid container sx={{ width: "100%", m: 0 }}>
          {sites.map((site, index) => {
            const apiDeviceCount = deviceCounts[site.id];
            const calculatedDeviceCount =
              (site.accessPoints || 0) + (site.switches || 0);
            const deviceCount =
              apiDeviceCount !== undefined
                ? apiDeviceCount
                : calculatedDeviceCount;

            const subscriptions = siteSubscriptions[site.id] || {};

            return (
              <Grid
                item
                xs={12}
                md={6}
                key={site.id}
                sx={{
                  pl: { xs: 0, md: index % 2 === 0 ? 0 : 1.5 },
                  pr: { xs: 0, md: index % 2 === 0 ? 1.5 : 0 },
                  pb: 3,
                }}
              >
                <Box
                  sx={{
                    p: 2.5,
                    bgcolor: "common.white",
                    borderRadius: "15px",
                    border: `1px solid ${theme.palette.divider}`,
                    height: "100%",
                  }}
                >
                  <Stack spacing={2}>
                    <Stack direction='row' alignItems='center' spacing={1}>
                      <EnvironmentOutlined
                        style={{ fontSize: "16px", color: "#172664" }}
                      />
                      <Typography
                        variant='subtitle1'
                        sx={{ color: "rgba(0,0,0,0.85)", fontSize: "15px" }}
                      >
                        {site.name} -{" "}
                        <Box component='span' sx={{ fontWeight: "bold" }}>
                          {deviceCount} devices
                        </Box>
                      </Typography>
                    </Stack>

                    <Stack spacing={2}>
                      {siteLevelServices
                        .filter((service) => !service.name.includes("NMS"))
                        .map((service) => (
                          <ServiceCard
                            key={service.id}
                            title={service.name}
                            status={subscriptions[service.id] || "Inactive"}
                            price={service.price}
                            devices={deviceCount}
                            onAction={(action) =>
                              onAction &&
                              onAction({
                                ...service,
                                siteId: site.id,
                                siteName: site.name,
                                devices: deviceCount,
                                action,
                              })
                            }
                          />
                        ))}
                    </Stack>
                  </Stack>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Stack>
    </Box>
  );
};
export default SiteBasedBlock;
